import {
  CONFIRM_SIGNUP_EMAIL_PATH,
  ERROR_CONFIRM_SIGNUP_EMAIL_PATH,
  FORGOT_PASSWORD_PATH,
  PRIVACY,
  RESET_PASSWORD_PATH,
  SIGN_IN_PATH,
  SIGN_UP_CHOOSE_PARTNER_PATH,
  SIGN_UP_PATH,
  SIGN_UP_VERIFY_EMAIL_PATH,
  SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH,
} from 'constant/authenticationPath';
import Authentication from 'page/Authentication';
import ConfirmSignupEmail from 'page/Authentication/ConfirmSignupEmail';
import ResetPassword from 'page/Authentication/ForgotPassword/ResetPassword';
import VerifyEmail from 'page/Authentication/ForgotPassword/VerifyEmail';
import SignIn from 'page/Authentication/SignIn';
import SignUp from 'page/Authentication/SignUp';
import SignUpSelectPartner from 'page/Authentication/SignUpSelectPartner/index';
import SuccessConfirmSignupEmail from 'page/Authentication/SuccessConfirmSignupEmail';
import NotFound from 'page/NotFound';
import Privacy from 'page/Privacy';
import { createHashRouter } from 'react-router-dom';
import ErrorConfirmSignupEmail from 'page/Authentication/ErrorConfirmSignupEmail';
import SignUpVerifyEmail from 'page/Authentication/SignUpVerifyEmail';

export const authenticationRouter = createHashRouter([
  {
    path: '/',
    element: <Authentication />,
    errorElement: <NotFound />,
    children: [
      {
        path: SIGN_IN_PATH,
        element: <SignIn />,
      },
      {
        path: SIGN_UP_PATH,
        element: <SignUp />,
      },
      {
        path: SIGN_UP_PATH + '/' + SIGN_UP_CHOOSE_PARTNER_PATH,
        element: <SignUpSelectPartner />,
      },
      {
        path: FORGOT_PASSWORD_PATH,
        element: <VerifyEmail />,
      },
      {
        path: RESET_PASSWORD_PATH,
        element: <ResetPassword />,
      },
      {
        path: CONFIRM_SIGNUP_EMAIL_PATH,
        element: <ConfirmSignupEmail />,
      },
      {
        path: SIGN_UP_VERIFY_EMAIL_PATH,
        element: <SignUpVerifyEmail />,
      },
      {
        path: SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH,
        element: <SuccessConfirmSignupEmail />,
      },
      {
        path: ERROR_CONFIRM_SIGNUP_EMAIL_PATH,
        element: <ErrorConfirmSignupEmail />,
      },
    ],
  },
  {
    path: PRIVACY,
    element: <Privacy />,
  },
]);
